import React, { useEffect, useMemo, useRef, useState, } from "react";
import { colors, fonts, frames, glyphs, } from "../../Styles";
import { Button, NewInput, NewInputHandles, NewModal } from "..";
import { ButtonTypes, ListData_ValueTypes, TableStyles_Types } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { GenericDataParameters } from "../Tables/_Tables/useColumnConstructor";
import { useEditableColumnConstructor } from "../Tables/_Tables/useEditableColumnConstructor";
import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { ReactiveTable } from "../Tables/reactiveTableRenderer";
import { setStates } from "../../Store/StateHandlers/active-slice";
import { Pages, NavigationFunction as RootNavigation } from "../../Navigation/Routers/root";
import globalFilter from "../Tables/_Tables/useGlobalFilter";
interface siteListProps {
  ifSucces: () => void
}

export default function SiteListModal({ifSucces}:siteListProps) {
  const {t} = useTranslation()
  const { userFarms, getUserFarms, doLogOut, userToken } = useUser()
  const searchRef = useRef<NewInputHandles>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const dispatch = useDispatch()
  const navigator = useNavigate()

  localStorage.setItem("activedomain", "")

  var isTech = true

  useEffect(() => {
    getUserFarms()
  }, [])

  useEffect(() => {
    setGlobalFilterValue(searchTerm);
  }, [searchTerm]);

  const tableData = useMemo(() => (
    userFarms?.map((farm) => ({
      action: <Button content={farm.name}
        onClick={() => {
          //If the farm is as legacy system refer to legacy app
          if (farm.legacy) { 
            window.location.href = `${window.location.protocol}//${window.location.hostname}` + "/autopig-app" + "?jwt=" + encodeURIComponent(userToken??"");
          } else {
            dispatch(setStates({type:'farm', farm:farm.domain}));
            ifSucces()
          }
        }}
        buttonType={ButtonTypes.textButton}
        startEnhancer={<glyphs.ArrowSmooth fillColor={colors.greyDarkPrimary}/>}
        overrides={{
          contentStyles: {color: colors.greyDarkPrimary, ...fonts.fontSize4, ...fonts.paragraph},
          startEnhancerStyles: {marginRight: "15px"}
        }}
      />,
      id: farm.farm_id,
      farmName: farm.name,
      farmDomain: farm.domain,
    })) || []
  ), [dispatch, ifSucces, userFarms]);

  const accessorData = useMemo<GenericDataParameters[]>(() => ([
    {headerValue: `${t("loginFlow.chooseSite.siteName", {defaultValue: "site name"})}`, accessor: "action", type: ListData_ValueTypes.Button, staticColumn: true, sort: true, filter: true, width: "180px"},
    {headerValue: `${t("loginFlow.chooseSite.domain", {defaultValue: "domain"})}`, accessor: "farmDomain", type: ListData_ValueTypes.String, sort: true, filter: true},
    // {headerValue: `${t("loginFlow.chooseSite.id", {defaultValue: "id"})}`, accessor: "id", type: ListData_ValueTypes.Number, sort: true, filter: true},
  ]),[t]);

  const columns = useEditableColumnConstructor({
    accessorData: [...accessorData],
    tableStyle: TableStyles_Types.blueTable,
    canEdit: false
  });

  const table = useReactTable({
    columns,
    data: tableData,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    globalFilterFn: globalFilter,
    state: {
      globalFilter: globalFilterValue,
      columnPinning: {
        left: ["action"]
      }
    },
    onGlobalFilterChange: setGlobalFilterValue,
  })

  // const reactiveTable = useMemo(() => {if (tableData.length!==0) {return ReactiveTable({table, tableType: TableStyles_Types.blueTable, emptyText: t("loginFlow.login.noSitesFound", {defaultValue: "no sites found"}), renderFooter: false})}}, [t, table, tableData.length])

  const reactiveTable = ReactiveTable({
    table,
    tableType: TableStyles_Types.blueTable,
    emptyText: t("loginFlow.login.noSitesFound", {defaultValue: "no sites found"}),
    renderFooter: false,
  });

  return (
    <frames.DecorBg>
      <NewModal
        modalState
        header={t("loginFlow.chooseSite.chooseSite", {defaultValue: "choose site"})}
        overrides={{
          overlayColor: colors.blackPrimary+"99"
        }}
        topRightContent={
          <Button content={t("loginFlow.login.logOut", {defaultValue: "log out"})}
            startEnhancer={glyphs.Arrow({rotate: 180})}
            onClick={() => doLogOut()}
            buttonType={ButtonTypes.textButton}
          />
        }
        topLeftContent={ <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "end", gap: " 0px 10px"}}>
          <Button content={t("user.userInformation", {defaultValue: "user information"})}
            startEnhancer={glyphs.User({})}
            onClick={() => {RootNavigation(navigator, Pages.userInformations)} }
            buttonType={ButtonTypes.textButton}
            overrides={{
              contentStyles: {whiteSpace: "nowrap"}
            }}
          />
          {isTech && (
            <Button content={t("loginFlow.chooseSite.tools", {defaultValue: "tools"})}
              startEnhancer={<glyphs.Setting/>}
              buttonType={ButtonTypes.textButton}
              onClick={() => {RootNavigation(navigator, Pages.graphQl)} }
            />
          )}
        </div>}
        headerContent={
        <NewInput
          ref={searchRef}
          onChange={(value: string) => {
            setSearchTerm(value);
            setGlobalFilterValue(value);
            console.log("Search Term:", value); 
          }}
          placeholder={t("search", { defaultValue: "search" })}
        />
        }
        mainContent={
          <div style={{width: "100%", minWidth: "300px"}}>{reactiveTable}</div>
        }
      />
    </frames.DecorBg>
  )
}